<template>
	<div
		class="progress"
		v-tooltip="`Total Orders: ${ordersTotal}`">
		<div
			class="progress-bar bg-success"
			role="progressbar"
			aria-valuemin="0"
			:aria-valuenow="successPickupsTotal"
			:aria-valuemax="ordersTotal"
			:style="`width: ${successPickupsPercentage}%`">
			{{ successPickupsTotal }}
		</div>
		<div
			class="progress-bar bg-danger"
			role="progressbar"
			aria-valuemin="0"
			:aria-valuenow="failedPickupsTotal"
			:aria-valuemax="ordersTotal"
			:style="`width: ${failedPickupsPercentage}%`">
			{{ failedPickupsTotal }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'PickupProgress',
	props: {
		ordersTotal: {
			type: Number,
			default: 0,
		},
		pickups: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		successPickupsTotal() {
			// eslint-disable-next-line camelcase
			const success = this.pickups.filter(({ is_pickup_success }) => is_pickup_success);
			return success.length;
		},
		failedPickupsTotal() {
			// eslint-disable-next-line camelcase
			const failed = this.pickups.filter(({ is_pickup_success }) => !is_pickup_success);
			return failed.length;
		},
		successPickupsPercentage() {
			return Math.floor((this.successPickupsTotal / this.ordersTotal) * 100);
		},
		failedPickupsPercentage() {
			return Math.floor((this.failedPickupsTotal / this.ordersTotal) * 100);
		},
	},
};
</script>
